const msalAuthConfiguration = {
  clientId: "f0b73dba-a463-44fe-920c-0d58f6e9c2f2",
  redirectUri: "http://localhost:3000/ms-callback",
  authority: "https://login.microsoftonline.com/organizations",
};

// if (process.env.NODE_ENV === "production") {
//   msalAuthConfiguration.redirectUri = "https://test-tpcos.scgp.co.th/ms-callback";
// }

if (process.env.NODE_ENV === "production") {
  msalAuthConfiguration.redirectUri = "https://tpcos.scg.com/ms-callback";
}

export { msalAuthConfiguration };
